<template>
  <div class="c-rating">
    <ul class="c-rating__stars">
      <li v-for="item in 5" :key="item" class="c-rating__star" :class="rating >= item && 'is-active'">
        <svg viewBox="0 0 40 38" xmlns="http://www.w3.org/2000/svg">
          <polygon fill-rule="evenodd" points="215 31.5088251 202.63932 38 205 24.2514708 195 14.5147084 208.81966 12.5088251 215 0 221.18034 12.5088251 235 14.5147084 225 24.2514708 227.36068 38" stroke="none" transform="translate(-195.000000, 0)" />
        </svg>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Star',
  props: [
    'rating'
  ]
}
</script>
